import React from "react";
import styled from "styled-components";
import Button from "./core-components/Button.tsx";

const MenuWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: row;
  background-color: white;
  justify-content: space-between;
  gap: 8px;
  padding: 16px;
  border-bottom: 2px solid #f2f2f2;
`;
const Title = styled.p`
  margin: 0;
  color: var(--primary-font-color);
  font-size: 1.2rem;
  font-family: Verdana, sans-serif;
  padding: 0.5rem;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

// const Button = styled.button`
//   border: 2px solid var(--primary-green);
//   color: var(--primary-green);
//   border-radius: 8px;
//   padding: 8px;
//   background-color: transparent;
//   cursor: pointer;
//   font-size: 1.2rem;

//   &:hover {
//     background-color: var(--background-green);
//   }
// `;

interface InputFieldProps {
  pageTitle: string;
  actionButtons?: {
    label: string;
    onClick: () => void;
    isEmpty?: boolean;
  }[];
}

const PageHeader: React.FC<InputFieldProps> = ({
  pageTitle,
  actionButtons,
}) => {
  return (
    <MenuWrapper data-testid="page-header">
      <Title>{pageTitle}</Title>
      <ButtonsWrapper>
        {actionButtons &&
          actionButtons.map((button) => (
            <Button
              key={button.label}
              id={`action-${button.label}`}
              onClick={button.onClick}
              text={button.label}
              backgroundColor={
                button.isEmpty ? "white" : "var(--secondary-green)"
              }
              outline={button.isEmpty ? "var(--secondary-green)" : "white"}
              color={button.isEmpty ? "var(--secondary-green)" : "white"}
            />
          ))}
      </ButtonsWrapper>
    </MenuWrapper>
  );
};

export default PageHeader;
